import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var content = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1ieo1f16',variantClassNames:{animation:{'default':'fx_2d2fb1e5_1ieo1f17',slideFromBottom:'fx_2d2fb1e5_1ieo1f18',slideFromRight:'fx_2d2fb1e5_1ieo1f19'}},defaultVariants:{},compoundVariants:[]});
var contentRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1ieo1f1a',variantClassNames:{hasAsideChild:{true:'fx_2d2fb1e5_1ieo1f1b'}},defaultVariants:{},compoundVariants:[]});

export { content, contentRoot };
//# sourceMappingURL=content.vanilla.mjs.map
